import { PermissionDenyErrorBox } from 'quick-quote/product-selection/components/permission-deny-error-box'

export default (hoc) => hoc(PermissionDenyErrorBox)
